import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

//static generic components
import "./styles.scss";
import {getResolutionName} from '../../containers/WorkkardDetail/utils';
import { StringConstants } from '../../containers/WorkkardDetail/constants';
// import FieldRenderingEngine from "../FieldRenderingEngine";
import FieldDisplayEngine from "../FieldDisplayEngine";
import UserImage from "../UserImage";
import { selectUserById } from '../../common/slice/userList';
import { selectOrgById } from '../../common/slice/orgList';

const getUserFullName = (reduxUser, fallbackFirstName, fallbackLastName) => {
  if (!reduxUser) return `${fallbackFirstName || ''} ${fallbackLastName || ''}`;
  const firstName = reduxUser.first_name;
  const lastName = reduxUser.last_name;
  return `${firstName || ''} ${lastName || ''}`;
};

const getOrgName = (reduxOrg, fallbackName) => {
  if (!reduxOrg) return fallbackName || '';
  return  reduxOrg.name  ?? '';
};

const ActivityListing=(props) =>{
  const isAssigneeOrg = !(parseInt(props.data.activityAssigneeId) > 0);
  const owner = useSelector(selectUserById(props.data.activityOwnerId));
  const assignee = useSelector(selectUserById(props.data.activityAssigneeId));
  const assigneeOrg = useSelector(selectOrgById(isAssigneeOrg ? props.data.assigneeOrgId : null));
  const openMiniProfile = (targetRect) => {
    const activityData = props.data;
    let userTitle = StringConstants.ActivityOwnerText
    let ownerId = parseInt(activityData.activityOwnerId)
    let assigneeId = parseInt(activityData.activityAssigneeId)
    const isSamePerson = assigneeId && assigneeId == ownerId;
    if (isSamePerson){
      userTitle = StringConstants.ActivityOwnerAssigneeText
    }
    const data = isSamePerson
      ? [{ id: ownerId, type: 'user', title: userTitle }]
      : [
          { id: ownerId, type: 'user', title: userTitle },
          { id: assigneeId > 0 ? assigneeId : activityData.assigneeOrgId, type: assigneeId ? 'user' : 'org', title: StringConstants.ActivityAssigneeText }
        ];

    const payload = {
      target: targetRect,
      data:data
    }
    props.onCellClick(payload);
  }

  const onMouseEnter = (e) => {
    const targetRect = e.currentTarget.getBoundingClientRect();
    setTimeout(() => openMiniProfile(targetRect),500)
  }

    const renderCustomFields = (renderProps, activityData, extraData) => {
      
      let sessionContext = extraData && extraData.sessionContext ? extraData.sessionContext :null;
      if (activityData && activityData.hasOwnProperty('customFields') && activityData.customFields?.length > 0  && sessionContext)
      {
          return <FieldDisplayEngine
                  userTimezone={sessionContext.TimeZoneTz}
                  tzData={sessionContext.tzData} 
                  data={activityData.customFields}
                  renderType={'activityListing'} {...renderProps}
                  renderLocation={'detail'}
                   />
      }
      else {
          return null;
      }
    }

  return (
    <li className={props.selectedId == props.data.activityId ? "card active" : "card"} key={props.data.activityId} onClick={()=>props.onItemClick(props.data.activityId)}>
    <p className="title" title={props.data.activityName}>{props.data.activityName}</p>
    <br></br>
    {
        renderCustomFields({
          excludeFields: ['Customer Name', 'Attach Files', 'Property Location'],
          showLabel: true
      } , props.data, props.extraData)
    }
   
    <dl>
      <dd className={`status ${getResolutionName(props.data.resolution.toLowerCase(),true)}`}>{getResolutionName(props.data.resolution)}</dd> 
    </dl>
    <div className="posRight rowFlex posBottom">
        <div className="dropDown" onMouseEnter={onMouseEnter}>
          <span className="badges badgesSmall overlap">
            <UserImage profileUrl={props.data.activityOwnerImageUrl}size="22" profileName={getUserFullName(owner, props.data.activityOwnerUserFirstName, props.data.activityOwnerUserLastName)}/>
          </span>
          <span className="badges badgesSmall">
              {isAssigneeOrg ? (
                <UserImage profileUrl={assigneeOrg?.profile_image || props.data.assigneeOrgImage} size="22" profileName={getOrgName(assigneeOrg, props.data.assigneeOrgName)}/>
              ) : (
                <UserImage profileUrl={props.data.activityAssigneeImageUrl} size="22" profileName={getUserFullName(assignee, props.data.activityAssigneeUserFirstName, props.data.activityAssigneeUserLastName)}/>
              )}
         </span>
        </div>
    </div>
  </li>
  )
}

export default ActivityListing;